import { displayDate } from 'shared/libs/dayjs/helpers'
import { apiDateFormatDayMonthYear } from 'shared/libs/dayjs/model'

import { User } from 'modules/AccessManage/types'
import UserInfoWrapper from 'modules/AccessManage/ui/UserInfoWrapper'

import ListInfo from 'shared/ui/ListInfo'
import SkeletonNode from 'shared/ui/SkeletonNode'

interface Props {
  userInfo: User | null
  isFetching: boolean
}

const labelClassname = 'w-[200px] leading-[24px] text-[16px] text-light_gray_4'
const valueClassname = 'leading-[24px] text-[16px] text-dark'
const UserInfo = ({ userInfo, isFetching }: Props) => {
  return (
    <UserInfoWrapper title="О пользователе">
      <ListInfo gap={24}>
        <li className="!justify-start">
          <span className={labelClassname}>ФИО</span>
          <SkeletonNode
            loading={isFetching}
            className="!h-6 !w-full !max-w-[200px]"
          >
            <span className={valueClassname}>{userInfo?.full_name ?? '-'}</span>
          </SkeletonNode>
        </li>
        <li className="!justify-start">
          <span className={labelClassname}>Номер телефона</span>
          <SkeletonNode
            loading={isFetching}
            className="!h-6 !w-full !max-w-[200px]"
          >
            <span className={valueClassname}>
              {userInfo?.phone_number ?? '-'}
            </span>
          </SkeletonNode>
        </li>
        <li className="!justify-start">
          <span className={labelClassname}>Дата рождения</span>
          <SkeletonNode
            loading={isFetching}
            className="!h-6 !w-full !max-w-[200px]"
          >
            <span className={valueClassname}>
              {userInfo?.date_of_birth
                ? displayDate(userInfo.date_of_birth, apiDateFormatDayMonthYear)
                : '-'}
            </span>
          </SkeletonNode>
        </li>
        <li className="!justify-start">
          <span className={labelClassname}>Контактное лицо</span>
          <SkeletonNode
            loading={isFetching}
            className="!h-6 !w-full !max-w-[200px]"
          >
            <span className={valueClassname}>
              {userInfo?.contact_name ?? '-'}
            </span>
          </SkeletonNode>
        </li>
        <li className="!justify-start">
          <span className={labelClassname}>Кем приходится пользователю</span>
          <SkeletonNode
            loading={isFetching}
            className="!h-6 !w-full !max-w-[200px]"
          >
            <span className={valueClassname}>{userInfo?.contact ?? '-'}</span>
          </SkeletonNode>
        </li>
        <li className="!justify-start">
          <span className={labelClassname}>
            Номер телефона контактного лица
          </span>
          <SkeletonNode
            loading={isFetching}
            className="!h-6 !w-full !max-w-[200px]"
          >
            <span className={valueClassname}>
              {userInfo?.contact_phone_number ?? '-'}
            </span>
          </SkeletonNode>
        </li>
        <li className="!justify-start">
          <span className={labelClassname}>Электронная почта</span>
          <SkeletonNode
            loading={isFetching}
            className="!h-6 !w-full !max-w-[200px]"
          >
            <span className={valueClassname}>{userInfo?.email || '-'}</span>
          </SkeletonNode>
        </li>
        <li className="!justify-start">
          <span className={labelClassname}>Бренд</span>
          <SkeletonNode
            loading={isFetching}
            className="!h-6 !w-full !max-w-[200px]"
          >
            <span className={valueClassname}>
              {userInfo?.company?.name ?? '-'}
            </span>
          </SkeletonNode>
        </li>
        <li className="!justify-start">
          <span className={labelClassname}>Филиал</span>
          <SkeletonNode
            loading={isFetching}
            className="!h-6 !w-full !max-w-[200px]"
          >
            <span className={valueClassname}>
              {userInfo?.branch?.title ?? '-'}
            </span>
          </SkeletonNode>
        </li>
        <li className="!justify-start">
          <span className={labelClassname}>Роль</span>
          <SkeletonNode
            loading={isFetching}
            className="!h-6 !w-full !max-w-[200px]"
          >
            <span className={valueClassname}>
              {userInfo?.role?.name ?? '-'}
            </span>
          </SkeletonNode>
        </li>
        <li className="!justify-start">
          <span className={labelClassname}>Дата приглашения</span>
          <SkeletonNode
            loading={isFetching}
            className="!h-6 !w-full !max-w-[200px]"
          >
            <span className={valueClassname}>
              {userInfo?.created_at
                ? displayDate(userInfo.created_at, apiDateFormatDayMonthYear)
                : '-'}
            </span>
          </SkeletonNode>
        </li>
      </ListInfo>
    </UserInfoWrapper>
  )
}

export default UserInfo
